// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../font/digital-7.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*media breaks*/
@font-face {
  font-family: "digital-clock-font";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.cctv-admin-home {
  width: 100vw;
}
.cctv-admin-home .cctv-header {
  margin: 0;
  margin-bottom: 1vh;
  text-align: left;
  padding: 0 2vw;
  background-image: linear-gradient(to left, #fff, #2c53a0);
  color: #fff;
  position: sticky;
  width: 100%;
  text-transform: none;
}
@media (max-width: 1000px) {
  .cctv-admin-home .cctv-header {
    font-size: 1.5rem;
  }
}
@media (max-width: 600px) {
  .cctv-admin-home .cctv-header {
    font-size: 1.2rem;
  }
}
.cctv-admin-home .cctv-lookup {
  width: 95%;
  display: flex;
  gap: 1vw;
  position: relative;
  margin-bottom: 1vh;
}
.cctv-admin-home .cctv-lookup .cctv-btns {
  position: absolute;
  right: 0;
  display: flex;
  gap: 0.5vw;
}
.cctv-admin-home .cctv-lookup .cctv-filters {
  display: flex;
  flex-direction: column;
  gap: 0.5vh;
}
.cctv-admin-home .cctv-lookup .cctv-filters select {
  width: 100%;
  border-radius: 5px;
  width: 200px;
  height: 4vh;
}
.cctv-admin-home .cctv-lookup .cctv-search {
  display: flex;
  flex-direction: column;
  gap: 0.5vh;
}
.cctv-admin-home .cctv-lookup .cctv-search .single-search {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  position: relative;
  gap: 2px;
}
.cctv-admin-home .cctv-lookup .cctv-search .single-search input {
  height: 4vh;
  border-radius: 0.3rem;
  outline: none;
  padding: 2px 5px;
  border: 1px solid rgb(179, 172, 172);
}
.cctv-admin-home .cctv-lookup .cctv-search .single-search .search-btn {
  position: absolute;
  right: 5px;
  height: 3.25vh;
  border-radius: 0.3rem;
  box-shadow: none;
}
.cctv-admin-home .cctv-lookup .cctv-search .single-search .date-input {
  width: 50%;
}
.cctv-admin-home .cctv-lookup .cctv-search .single-search span {
  color: #000;
}
.cctv-admin-home .cctv-lookup .cctv-search .single-search .date-search-btn {
  width: 15%;
}
.cctv-admin-home .cctv-admin-table-container {
  overflow-y: auto;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
.cctv-admin-home .cctv-admin-table-container .cctv-admin-table {
  width: 95vw;
  font-size: 0.9em;
  font-family: sans-serif;
  table-layout: fixed;
}
.cctv-admin-home .cctv-admin-table-container .cctv-admin-table thead {
  height: 4vh;
}
.cctv-admin-home .cctv-admin-table-container .cctv-admin-table thead tr {
  background-color: #2c53a0;
  color: #ffffff;
  text-align: left;
}
.cctv-admin-home .cctv-admin-table-container .cctv-admin-table thead tr th {
  text-align: center;
}
.cctv-admin-home .cctv-admin-table-container .cctv-admin-table tbody tr {
  border-bottom: 1px solid #dddddd;
}
.cctv-admin-home .cctv-admin-table-container .cctv-admin-table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}
.cctv-admin-home .cctv-admin-table-container .cctv-admin-table tbody tr:first-of-type {
  border-top: 2px solid #2c53a0;
}
.cctv-admin-home .cctv-admin-table-container .cctv-admin-table tbody tr:last-of-type {
  border-bottom: 2px solid #2c53a0;
}
.cctv-admin-home .cctv-admin-table-container .cctv-admin-table tbody tr td {
  text-align: center;
  padding: 12px 15px;
  word-wrap: break-word;
  color: black;
  font-size: 1rem;
  font-weight: 500;
}
.cctv-admin-home .cctv-admin-table-container .cctv-admin-table tbody tr td .input_number {
  border-radius: 3px;
  border: 2px solid #2c53a0;
  width: 50px;
  height: 3vh;
  text-align: center;
}
.cctv-admin-home .cctv-admin-table-container .cctv-admin-table tbody tr td input::-webkit-outer-spin-button,
.cctv-admin-home .cctv-admin-table-container .cctv-admin-table tbody tr td input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.cctv-admin-home .cctv-admin-table-container .cctv-admin-table tbody tr td .info-icon {
  cursor: pointer;
}
.cctv-admin-home .cctv-admin-table-container .cctv-admin-table tbody tr .status-cell {
  display: flex;
  flex-direction: column;
}
.cctv-admin-home .cctv-admin-table-container .cctv-admin-table tbody .not-actioned {
  background-color: #f8ac48;
}
.cctv-admin-home .cctv-admin-table-container .cctv-admin-table tbody .not-actioned:nth-of-type(even) {
  background-color: #f8ac48;
}

.cctv-status-modal {
  display: flex;
  flex-direction: column;
}
.cctv-status-modal h1 {
  font-size: 2rem;
  margin: 0;
  box-shadow: 0 4px 2px -2px rgb(124, 124, 124);
  margin-bottom: 1vh;
  text-transform: none;
}
.cctv-status-modal p {
  color: #000;
  text-align: center;
  margin: 0.5vh;
}
.cctv-status-modal .existing-status {
  color: rgb(182, 11, 11);
  font-weight: 600;
}
.cctv-status-modal select {
  border-radius: 5px;
  height: 4vh;
  margin-bottom: 1vh;
}
.cctv-status-modal .alert-section {
  height: 7vh;
}
.cctv-status-modal .btn-section {
  display: flex;
  justify-content: space-between;
  gap: 1vw;
}
.cctv-status-modal .btn-section button {
  width: 100%;
}

.cctv-admin-info-modal {
  display: flex;
  flex-direction: column;
  gap: 1vh;
  color: #000;
  position: relative;
}
.cctv-admin-info-modal .request-identifier {
  position: absolute;
  bottom: 0;
  right: 10px;
  font-size: 0.6rem;
  font-weight: 700;
}
.cctv-admin-info-modal h1 {
  margin: 0;
  font-size: 1.5rem;
  display: flex;
  justify-content: space-between;
  box-shadow: 0 4px 2px -2px rgb(124, 124, 124);
  margin-bottom: 1vh;
  text-transform: none;
  color: #2c53a0;
}
.cctv-admin-info-modal h1 button {
  margin-bottom: 1vh;
}
.cctv-admin-info-modal img {
  cursor: pointer;
}
.cctv-admin-info-modal .top-section {
  display: flex;
  gap: 1vw;
  width: 100%;
  justify-content: space-between;
  height: 200px;
  max-height: 200px;
  text-align: left;
  overflow-y: auto;
}
.cctv-admin-info-modal .top-section .info-section {
  width: 50%;
}
.cctv-admin-info-modal .top-section .info-section h2 {
  text-align: left;
  margin: 0;
  font-size: 1rem;
  box-shadow: 0 4px 2px -2px rgb(124, 124, 124);
}
.cctv-admin-info-modal .top-section .info-section p {
  margin-top: 1vh;
}
.cctv-admin-info-modal .top-section .info-section .info-section-images img {
  max-height: 100px;
  max-width: 100px;
}
.cctv-admin-info-modal .bottom-section {
  display: flex;
  gap: 1vw;
  width: 100%;
  height: 300px;
}
.cctv-admin-info-modal .bottom-section .tab-box {
  width: 100%;
  border-top: 1px solid rgb(128, 128, 128);
}
.cctv-admin-info-modal .bottom-section .tab-box .tab-menu-section {
  margin-bottom: 1.5vh;
}
.cctv-admin-info-modal .bottom-section .tab-box .note-table-container {
  overflow-y: auto;
  height: 270px;
  max-height: 270px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
.cctv-admin-info-modal .bottom-section .tab-box .note-table-container .note-table {
  width: 100%;
  font-size: 0.9em;
  font-family: sans-serif;
  table-layout: fixed;
}
.cctv-admin-info-modal .bottom-section .tab-box .note-table-container .note-table thead {
  height: 4vh;
}
.cctv-admin-info-modal .bottom-section .tab-box .note-table-container .note-table thead tr {
  background-color: #2c53a0;
  color: #ffffff;
  text-align: left;
}
.cctv-admin-info-modal .bottom-section .tab-box .note-table-container .note-table thead tr th {
  text-align: center;
}
.cctv-admin-info-modal .bottom-section .tab-box .note-table-container .note-table tbody tr {
  border-bottom: 1px solid #dddddd;
}
.cctv-admin-info-modal .bottom-section .tab-box .note-table-container .note-table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}
.cctv-admin-info-modal .bottom-section .tab-box .note-table-container .note-table tbody tr:first-of-type {
  border-top: 2px solid #2c53a0;
}
.cctv-admin-info-modal .bottom-section .tab-box .note-table-container .note-table tbody tr:last-of-type {
  border-bottom: 2px solid #2c53a0;
}
.cctv-admin-info-modal .bottom-section .tab-box .note-table-container .note-table tbody tr td {
  text-align: center;
  padding: 12px 15px;
  word-wrap: break-word;
  color: black;
  font-size: 1rem;
  font-weight: 500;
}
.cctv-admin-info-modal .bottom-section .tab-box .note-table-container .note-table tbody tr td .input_number {
  border-radius: 3px;
  border: 2px solid #2c53a0;
  width: 50px;
  height: 3vh;
  text-align: center;
}
.cctv-admin-info-modal .bottom-section .tab-box .note-table-container .note-table tbody tr td input::-webkit-outer-spin-button,
.cctv-admin-info-modal .bottom-section .tab-box .note-table-container .note-table tbody tr td input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.cctv-admin-info-modal .bottom-section .create-admin-note {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1vh;
}
.cctv-admin-info-modal .bottom-section .create-admin-note textarea {
  border-radius: 5px;
  max-width: 100%;
  min-width: 100%;
  font-size: 1rem;
  padding: 5px;
  max-height: 150px;
  min-height: 150px;
}
.cctv-admin-info-modal .bottom-section .create-admin-note .alert-section {
  height: 7vh;
}
.cctv-admin-info-modal .bottom-section .crime-ref-section {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.cctv-admin-info-modal .bottom-section .crime-ref-section h2 {
  margin: 0.5vh auto;
}
.cctv-admin-info-modal .bottom-section .crime-ref-section h2 span {
  color: rgb(182, 11, 11);
}
.cctv-admin-info-modal .bottom-section .crime-ref-section p {
  text-align: center;
}
.cctv-admin-info-modal .bottom-section .crime-ref-section input {
  border-radius: 5px;
  height: 5vh;
  font-size: 1rem;
  width: 50%;
}
.cctv-admin-info-modal .bottom-section .crime-ref-section .alert-section {
  height: 7vh;
  margin: 0.5vh auto;
}
.cctv-admin-info-modal .bottom-section .crime-ref-section button {
  width: 50%;
}
.cctv-admin-info-modal .bottom-section .nmop-details {
  display: flex;
  gap: 1vw;
  width: 100%;
  justify-content: space-between;
  height: 270px;
  max-height: 270px;
  text-align: left;
  overflow-y: auto;
}
.cctv-admin-info-modal .bottom-section .nmop-details .no-nmop-details {
  margin: 0 auto;
}
.cctv-admin-info-modal .bottom-section .nmop-details .info-section {
  width: 50%;
}
.cctv-admin-info-modal .bottom-section .nmop-details .info-section h2 {
  text-align: left;
  margin: 0;
  font-size: 1rem;
  box-shadow: 0 4px 2px -2px rgb(124, 124, 124);
}
.cctv-admin-info-modal .bottom-section .nmop-details .info-section p {
  margin-top: 1vh;
}
.cctv-admin-info-modal .bottom-section .nmop-details .info-section img {
  max-height: 300px;
  max-width: 300px;
}
.cctv-admin-info-modal .bottom-section .investigation-tab .investigation-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1vh;
}
.cctv-admin-info-modal .bottom-section .investigation-tab .investigation-area p {
  text-align: center;
}
.cctv-admin-info-modal .bottom-section .investigation-tab .investigation-area input {
  border-radius: 5px;
  height: 5vh;
  font-size: 1rem;
  width: 50%;
}
.cctv-admin-info-modal .bottom-section .investigation-tab .investigation-area .alert-section {
  height: 7vh;
  margin: 0.5vh auto;
}
.cctv-admin-info-modal .bottom-section .investigation-tab .investigation-area button {
  width: 50%;
}
.cctv-admin-info-modal .bottom-section .investigation-tab .investigation-area .investigation-amount {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 95%;
}

.cctv-admin-form-modal {
  position: relative;
}
.cctv-admin-form-modal .toggle-btns {
  position: absolute;
  right: 20px;
}
.cctv-admin-form-modal .toggle-btns .toggle-btn {
  width: 100px;
}
.cctv-admin-form-modal h1 {
  margin: 0;
  font-size: 1.5rem;
  margin-bottom: 5vh;
}
.cctv-admin-form-modal .cctv-admin-form {
  display: flex;
  flex-direction: column;
  gap: 0.5vh;
}
.cctv-admin-form-modal .cctv-admin-form .form-type {
  min-height: 26vh;
}
.cctv-admin-form-modal .cctv-admin-form .form-row {
  display: flex;
  justify-content: space-between;
  gap: 1vw;
}
.cctv-admin-form-modal .cctv-admin-form .form-row .form-col {
  display: flex;
  flex-direction: column;
  gap: 1vh;
  align-items: flex-start;
  width: 100%;
}
.cctv-admin-form-modal .cctv-admin-form .form-row .form-col label {
  color: #000;
  font-weight: 500;
}
.cctv-admin-form-modal .cctv-admin-form .form-row .form-col input,
.cctv-admin-form-modal .cctv-admin-form .form-row .form-col select {
  border-radius: 5px;
  width: 100%;
  height: 4vh;
}
.cctv-admin-form-modal .cctv-admin-form .form-row .form-col textarea {
  border-radius: 5px;
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  height: 8vh;
  max-height: 8vh;
  min-height: 8vh;
}
.cctv-admin-form-modal .alert-section {
  height: 10vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cctv-admin-form-modal .btn-section {
  display: flex;
  justify-content: space-between;
  gap: 1vw;
  margin-top: 2vh;
}
.cctv-admin-form-modal .btn-section button {
  width: 100%;
}

.cctv-admin-help-modal h1 {
  margin: 0;
  font-size: 1.5rem;
  margin-bottom: 2vh;
}
.cctv-admin-help-modal .help-main-content {
  max-height: 40vh;
  min-height: 40vh;
  overflow-y: auto;
}
.cctv-admin-help-modal .help-main-content h2 {
  text-align: left;
  margin: 0;
  font-size: 1rem;
  box-shadow: 0 4px 2px -2px rgb(124, 124, 124);
}
.cctv-admin-help-modal .help-main-content p {
  color: #000;
}
.cctv-admin-help-modal .help-main-content p .unactioned-color {
  background-color: #f8ac48;
  width: 200px;
  height: 30px;
  margin-top: 5px;
}
.cctv-admin-help-modal button {
  margin-top: 2vh;
  width: 100%;
}

.upload-photo-modal {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 1vw;
}
.upload-photo-modal h1 {
  margin: 0;
  font-size: 1.5rem;
}
.upload-photo-modal .upload-section label {
  font-weight: 500;
  color: #000;
}
.upload-photo-modal .upload-section select {
  width: 100%;
  height: 4vh;
  border-radius: 5px;
}
.upload-photo-modal .upload-section .img-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 1vw;
  height: 30vh;
  border: 1px solid #000;
  margin: 1vh auto;
  position: relative;
}
.upload-photo-modal .upload-section .img-container img {
  max-height: 28vh;
  max-width: 100%;
}
.upload-photo-modal .upload-section .img-container .delete-icon {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}
.upload-photo-modal .upload-section input {
  width: 100%;
  height: 4vh;
  color: #000;
  border-radius: 5px;
  border: 1px solid #000;
  padding: 5px;
}
.upload-photo-modal .alert-section {
  height: 7vh;
}
.upload-photo-modal .btn-section {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 1vw;
  width: 100%;
}
.upload-photo-modal .btn-section button {
  width: 45%;
}`, "",{"version":3,"sources":["webpack://./src/components/variables.scss","webpack://./src/components/Fuel/cctv-admin/cctv-admin-home.scss"],"names":[],"mappings":"AAOA,eAAA;AAeA;EACI,iCAAA;EACA,4CAAA;ACpBJ;AAFA;EACI,YAAA;AAIJ;AAHI;EACI,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yDAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;AAKR;AAJQ;EAVJ;IAWQ,iBAAA;EAOV;AACF;AANQ;EAbJ;IAcQ,iBAAA;EASV;AACF;AANI;EACI,UAAA;EACA,aAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;AAQR;AAPQ;EACI,kBAAA;EACA,QAAA;EACA,aAAA;EACA,UAAA;AASZ;AANQ;EACI,aAAA;EACA,sBAAA;EACA,UAAA;AAQZ;AAPY;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AAShB;AANQ;EACI,aAAA;EACA,sBAAA;EACA,UAAA;AAQZ;AANY;EACI,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;AAQhB;AAPgB;EACI,WAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;EACA,oCAAA;AASpB;AAPgB;EACI,kBAAA;EACA,UAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;AASpB;AAPgB;EACI,UAAA;AASpB;AAPgB;EACI,WAAA;AASpB;AAPgB;EACI,UAAA;AASpB;AAHI;EACI,gBAAA;EACA,qDAAA;AAKR;AAJQ;EACI,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAMZ;AALY;EACI,WAAA;AAOhB;AANgB;EACI,yBD/FR;ECgGQ,cAAA;EACA,gBAAA;AAQpB;AAPoB;EACI,kBAAA;AASxB;AAHgB;EACI,gCAAA;AAKpB;AAHoB;EACI,yBAAA;AAKxB;AAHoB;EACI,6BAAA;AAKxB;AAHoB;EACI,gCAAA;AAKxB;AAFoB;EACI,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAIxB;AAHwB;EACI,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;AAK5B;AAHwB;;EAEI,wBAAA;EACA,SAAA;AAK5B;AAFwB;EACI,eAAA;AAI5B;AAAoB;EACI,aAAA;EACA,sBAAA;AAExB;AACgB;EACI,yBAAA;AACpB;AACoB;EACI,yBAAA;AACxB;;AAOA;EACI,aAAA;EACA,sBAAA;AAJJ;AAMI;EACI,eAAA;EACA,SAAA;EACA,6CAAA;EACA,kBAAA;EACA,oBAAA;AAJR;AAOI;EACI,WAAA;EACA,kBAAA;EACA,aAAA;AALR;AAOI;EACI,uBAAA;EACA,gBAAA;AALR;AAQI;EACI,kBAAA;EACA,WAAA;EACA,kBAAA;AANR;AASI;EACI,WAAA;AAPR;AAUI;EACI,aAAA;EACA,8BAAA;EACA,QAAA;AARR;AASQ;EACI,WAAA;AAPZ;;AAYA;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;AATJ;AAUI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AARR;AAUI;EACI,SAAA;EACA,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,6CAAA;EACA,kBAAA;EACA,oBAAA;EACA,cD/NI;ACuNZ;AASQ;EACI,kBAAA;AAPZ;AAUI;EACI,eAAA;AARR;AAUI;EACI,aAAA;EACA,QAAA;EACA,WAAA;EACA,8BAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AARR;AASQ;EACI,UAAA;AAPZ;AAQY;EACI,gBAAA;EACA,SAAA;EACA,eAAA;EACA,6CAAA;AANhB;AAQY;EACI,eAAA;AANhB;AAUgB;EACI,iBAAA;EACA,gBAAA;AARpB;AAcI;EACI,aAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;AAZR;AAaQ;EACI,WAAA;EACA,wCAAA;AAXZ;AAYY;EACI,oBAAA;AAVhB;AAYY;EACI,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,qDAAA;AAVhB;AAWgB;EACI,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AATpB;AAWoB;EACI,WAAA;AATxB;AAUwB;EACI,yBD9RhB;EC+RgB,cAAA;EACA,gBAAA;AAR5B;AAS4B;EACI,kBAAA;AAPhC;AAawB;EACI,gCAAA;AAX5B;AAa4B;EACI,yBAAA;AAXhC;AAa4B;EACI,6BAAA;AAXhC;AAa4B;EACI,gCAAA;AAXhC;AAc4B;EACI,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAZhC;AAagC;EACI,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;AAXpC;AAagC;;EAEI,wBAAA;EACA,SAAA;AAXpC;AAoBQ;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,QAAA;AAlBZ;AAmBY;EACI,kBAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AAjBhB;AAmBY;EACI,WAAA;AAjBhB;AAqBQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AAnBZ;AAoBY;EACI,kBAAA;AAlBhB;AAmBgB;EACI,uBAAA;AAjBpB;AAoBY;EACI,kBAAA;AAlBhB;AAoBY;EACI,kBAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;AAlBhB;AAoBY;EACI,WAAA;EACA,kBAAA;AAlBhB;AAoBY;EACI,UAAA;AAlBhB;AAsBQ;EACI,aAAA;EACA,QAAA;EACA,WAAA;EACA,8BAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AApBZ;AAqBY;EACI,cAAA;AAnBhB;AAqBY;EACI,UAAA;AAnBhB;AAoBgB;EACI,gBAAA;EACA,SAAA;EACA,eAAA;EACA,6CAAA;AAlBpB;AAoBgB;EACI,eAAA;AAlBpB;AAqBgB;EACI,iBAAA;EACA,gBAAA;AAnBpB;AAyBY;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AAvBhB;AAwBgB;EACI,kBAAA;AAtBpB;AAwBgB;EACI,kBAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;AAtBpB;AAwBgB;EACI,WAAA;EACA,kBAAA;AAtBpB;AAwBgB;EACI,UAAA;AAtBpB;AAyBgB;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAvBpB;;AA6BA;EACI,kBAAA;AA1BJ;AA2BI;EACI,kBAAA;EACA,WAAA;AAzBR;AA0BQ;EACI,YAAA;AAxBZ;AA2BI;EACI,SAAA;EACA,iBAAA;EACA,kBAAA;AAzBR;AA2BI;EACI,aAAA;EACA,sBAAA;EACA,UAAA;AAzBR;AA2BQ;EACI,gBAAA;AAzBZ;AA4BQ;EACI,aAAA;EACA,8BAAA;EACA,QAAA;AA1BZ;AA2BY;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,uBAAA;EAEA,WAAA;AA1BhB;AA2BgB;EACI,WAAA;EACA,gBAAA;AAzBpB;AA2BgB;;EAEI,kBAAA;EACA,WAAA;EACA,WAAA;AAzBpB;AA2BgB;EACI,kBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;AAzBpB;AA8BI;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA5BR;AA8BI;EACI,aAAA;EACA,8BAAA;EACA,QAAA;EACA,eAAA;AA5BR;AA6BQ;EACI,WAAA;AA3BZ;;AAiCI;EACI,SAAA;EACA,iBAAA;EACA,kBAAA;AA9BR;AAgCI;EACI,gBAAA;EACA,gBAAA;EACA,gBAAA;AA9BR;AA+BQ;EACI,gBAAA;EACA,SAAA;EACA,eAAA;EACA,6CAAA;AA7BZ;AAgCQ;EACI,WAAA;AA9BZ;AAgCY;EACI,yBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AA9BhB;AAkCI;EACI,eAAA;EACA,WAAA;AAhCR;;AAoCA;EDrfI,aAAA;EACA,eAAA;EACA,mBAHY;EAIZ,uBAJqB;EAKrB,mBALiC;EAMjC,QAN6C;AC2djD;AA6BI;EACI,SAAA;EACA,iBAAA;AA3BR;AA+BQ;EACI,gBAAA;EACA,WAAA;AA7BZ;AA+BQ;EACI,WAAA;EACA,WAAA;EACA,kBAAA;AA7BZ;AAgCQ;EDvgBJ,aAAA;EACA,eAAA;EACA,mBAHY;EAIZ,uBAJqB;EAKrB,mBALiC;EAMjC,QAN6C;EC0gBrC,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;AAzBZ;AA0BY;EACI,gBAAA;EACA,eAAA;AAxBhB;AA0BY;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,eAAA;AAxBhB;AA4BQ;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;AA1BZ;AA8BI;EACI,WAAA;AA5BR;AA+BI;EDviBA,aAAA;EACA,eAAA;EACA,mBAHY;EAIZ,uBAJqB;EAKrB,mBALiC;EAMjC,QAN6C;EC0iBzC,WAAA;AAxBR;AAyBQ;EACI,UAAA;AAvBZ","sourcesContent":["$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n\n/*media breaks*/\n$mobile: 600px;\n$tablet: 768px;\n$laptop: 900px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@font-face {\n    font-family: \"digital-clock-font\";\n    src: url(\"./Fuel/font/digital-7.ttf\");\n}\n\n@mixin shadow {\n    box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n@mixin card {\n    background-color: #fff;\n    @include shadow;\n    border-radius: 1rem;\n}\n\n@mixin alertCard {\n    box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px,\n        rgba(0, 0, 0, 0.23) 0px 6px 6px;\n    background-color: #fff;\n    border-radius: 0.5rem;\n}\n\n@mixin eposCard {\n    background-color: #fff;\n    box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px,\n        rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px,\n        rgba(0, 0, 0, 0.09) 0px 32px 16px;\n}\n\n@mixin flex($d: row, $j: center, $a: center, $g: 1vw) {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: $d;\n    justify-content: $j;\n    align-items: $a;\n    gap: $g;\n}\n\n@mixin columnStack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnStart {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n@mixin columnAlignStart {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin columnAlignStartTop {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin rowEven {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    flex-wrap: wrap;\n}\n\n@mixin rowEvenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n@mixin rowEvenStartCenter {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n}\n@mixin rowBetween {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin table {\n    table-layout: fixed;\n    background-color: #fff;\n    border-collapse: collapse;\n    color: $fontColor;\n    thead {\n        border-bottom: 1px solid $fontColor;\n        text-align: center;\n    }\n    tbody {\n        text-align: center;\n        tr {\n            border-bottom: 1px solid $fontColor;\n            &:nth-child(odd) {\n                background-color: #f2f2f2;\n            }\n            input {\n                width: 20%;\n                margin: 0 auto;\n                text-align: center;\n            }\n        }\n    }\n}\n\n//MODAL STYLING\n\n@mixin modal($h: auto, $w: auto) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: $w;\n    height: $h;\n    max-height: 50vh;\n    background-color: #fff;\n    border: 2px solid #000;\n    box-shadow: 24;\n    padding: 10px;\n    overflow-y: auto;\n    @media (max-width: 600px) {\n        width: 95vw;\n    }\n}\n","@import \"../../variables.scss\";\n\n.cctv-admin-home {\n    width: 100vw;\n    .cctv-header {\n        margin: 0;\n        margin-bottom: 1vh;\n        text-align: left;\n        padding: 0 2vw;\n        background-image: linear-gradient(to left, #fff, $nitroDark);\n        color: #fff;\n        position: sticky;\n        width: 100%;\n        text-transform: none;\n        @media (max-width: 1000px) {\n            font-size: 1.5rem;\n        }\n        @media (max-width: 600px) {\n            font-size: 1.2rem;\n        }\n    }\n\n    .cctv-lookup {\n        width: 95%;\n        display: flex;\n        gap: 1vw;\n        position: relative;\n        margin-bottom: 1vh;\n        .cctv-btns {\n            position: absolute;\n            right: 0;\n            display: flex;\n            gap: 0.5vw;\n        }\n\n        .cctv-filters {\n            display: flex;\n            flex-direction: column;\n            gap: 0.5vh;\n            select {\n                width: 100%;\n                border-radius: 5px;\n                width: 200px;\n                height: 4vh;\n            }\n        }\n        .cctv-search {\n            display: flex;\n            flex-direction: column;\n            gap: 0.5vh;\n\n            .single-search {\n                display: flex;\n                justify-content: space-evenly;\n                align-items: center;\n                position: relative;\n                gap: 2px;\n                input {\n                    height: 4vh;\n                    border-radius: 0.3rem;\n                    outline: none;\n                    padding: 2px 5px;\n                    border: 1px solid rgb(179, 172, 172);\n                }\n                .search-btn {\n                    position: absolute;\n                    right: 5px;\n                    height: 3.25vh;\n                    border-radius: 0.3rem;\n                    box-shadow: none;\n                }\n                .date-input {\n                    width: 50%;\n                }\n                span {\n                    color: #000;\n                }\n                .date-search-btn {\n                    width: 15%;\n                }\n            }\n        }\n    }\n\n    .cctv-admin-table-container {\n        overflow-y: auto;\n        box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n        .cctv-admin-table {\n            width: 95vw;\n            font-size: 0.9em;\n            font-family: sans-serif;\n            table-layout: fixed;\n            thead {\n                height: 4vh;\n                tr {\n                    background-color: $nitroDark;\n                    color: #ffffff;\n                    text-align: left;\n                    th {\n                        text-align: center;\n                    }\n                }\n            }\n\n            tbody {\n                tr {\n                    border-bottom: 1px solid #dddddd;\n\n                    &:nth-of-type(even) {\n                        background-color: #f3f3f3;\n                    }\n                    &:first-of-type {\n                        border-top: 2px solid $nitroDark;\n                    }\n                    &:last-of-type {\n                        border-bottom: 2px solid $nitroDark;\n                    }\n\n                    td {\n                        text-align: center;\n                        padding: 12px 15px;\n                        word-wrap: break-word;\n                        color: black;\n                        font-size: 1rem;\n                        font-weight: 500;\n                        .input_number {\n                            border-radius: 3px;\n                            border: 2px solid $nitroDark;\n                            width: 50px;\n                            height: 3vh;\n                            text-align: center;\n                        }\n                        input::-webkit-outer-spin-button,\n                        input::-webkit-inner-spin-button {\n                            -webkit-appearance: none;\n                            margin: 0;\n                        }\n\n                        .info-icon {\n                            cursor: pointer;\n                        }\n                    }\n\n                    .status-cell {\n                        display: flex;\n                        flex-direction: column;\n                    }\n                }\n                .not-actioned {\n                    background-color: #f8ac48;\n\n                    &:nth-of-type(even) {\n                        background-color: #f8ac48;\n                    }\n                }\n            }\n        }\n    }\n}\n\n.cctv-status-modal {\n    display: flex;\n    flex-direction: column;\n\n    h1 {\n        font-size: 2rem;\n        margin: 0;\n        box-shadow: 0 4px 2px -2px rgb(124, 124, 124);\n        margin-bottom: 1vh;\n        text-transform: none;\n    }\n\n    p {\n        color: #000;\n        text-align: center;\n        margin: 0.5vh;\n    }\n    .existing-status {\n        color: rgb(182, 11, 11);\n        font-weight: 600;\n    }\n\n    select {\n        border-radius: 5px;\n        height: 4vh;\n        margin-bottom: 1vh;\n    }\n\n    .alert-section {\n        height: 7vh;\n    }\n\n    .btn-section {\n        display: flex;\n        justify-content: space-between;\n        gap: 1vw;\n        button {\n            width: 100%;\n        }\n    }\n}\n\n.cctv-admin-info-modal {\n    display: flex;\n    flex-direction: column;\n    gap: 1vh;\n    color: #000;\n    position: relative;\n    .request-identifier {\n        position: absolute;\n        bottom: 0;\n        right: 10px;\n        font-size: 0.6rem;\n        font-weight: 700;\n    }\n    h1 {\n        margin: 0;\n        font-size: 1.5rem;\n        display: flex;\n        justify-content: space-between;\n        box-shadow: 0 4px 2px -2px rgb(124, 124, 124);\n        margin-bottom: 1vh;\n        text-transform: none;\n        color: $nitroDark;\n        button {\n            margin-bottom: 1vh;\n        }\n    }\n    img {\n        cursor: pointer;\n    }\n    .top-section {\n        display: flex;\n        gap: 1vw;\n        width: 100%;\n        justify-content: space-between;\n        height: 200px;\n        max-height: 200px;\n        text-align: left;\n        overflow-y: auto;\n        .info-section {\n            width: 50%;\n            h2 {\n                text-align: left;\n                margin: 0;\n                font-size: 1rem;\n                box-shadow: 0 4px 2px -2px rgb(124, 124, 124);\n            }\n            p {\n                margin-top: 1vh;\n            }\n\n            .info-section-images {\n                img {\n                    max-height: 100px;\n                    max-width: 100px;\n                }\n            }\n        }\n    }\n\n    .bottom-section {\n        display: flex;\n        gap: 1vw;\n        width: 100%;\n        height: 300px;\n        .tab-box {\n            width: 100%;\n            border-top: 1px solid rgb(128, 128, 128);\n            .tab-menu-section {\n                margin-bottom: 1.5vh;\n            }\n            .note-table-container {\n                overflow-y: auto;\n                height: 270px;\n                max-height: 270px;\n                box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n                .note-table {\n                    width: 100%;\n                    font-size: 0.9em;\n                    font-family: sans-serif;\n                    table-layout: fixed;\n\n                    thead {\n                        height: 4vh;\n                        tr {\n                            background-color: $nitroDark;\n                            color: #ffffff;\n                            text-align: left;\n                            th {\n                                text-align: center;\n                            }\n                        }\n                    }\n\n                    tbody {\n                        tr {\n                            border-bottom: 1px solid #dddddd;\n\n                            &:nth-of-type(even) {\n                                background-color: #f3f3f3;\n                            }\n                            &:first-of-type {\n                                border-top: 2px solid $nitroDark;\n                            }\n                            &:last-of-type {\n                                border-bottom: 2px solid $nitroDark;\n                            }\n\n                            td {\n                                text-align: center;\n                                padding: 12px 15px;\n                                word-wrap: break-word;\n                                color: black;\n                                font-size: 1rem;\n                                font-weight: 500;\n                                .input_number {\n                                    border-radius: 3px;\n                                    border: 2px solid $nitroDark;\n                                    width: 50px;\n                                    height: 3vh;\n                                    text-align: center;\n                                }\n                                input::-webkit-outer-spin-button,\n                                input::-webkit-inner-spin-button {\n                                    -webkit-appearance: none;\n                                    margin: 0;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n\n        .create-admin-note {\n            display: flex;\n            flex-direction: column;\n            width: 100%;\n            gap: 1vh;\n            textarea {\n                border-radius: 5px;\n                max-width: 100%;\n                min-width: 100%;\n                font-size: 1rem;\n                padding: 5px;\n                max-height: 150px;\n                min-height: 150px;\n            }\n            .alert-section {\n                height: 7vh;\n            }\n        }\n\n        .crime-ref-section {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            h2 {\n                margin: 0.5vh auto;\n                span {\n                    color: rgb(182, 11, 11);\n                }\n            }\n            p {\n                text-align: center;\n            }\n            input {\n                border-radius: 5px;\n                height: 5vh;\n                font-size: 1rem;\n                width: 50%;\n            }\n            .alert-section {\n                height: 7vh;\n                margin: 0.5vh auto;\n            }\n            button {\n                width: 50%;\n            }\n        }\n\n        .nmop-details {\n            display: flex;\n            gap: 1vw;\n            width: 100%;\n            justify-content: space-between;\n            height: 270px;\n            max-height: 270px;\n            text-align: left;\n            overflow-y: auto;\n            .no-nmop-details {\n                margin: 0 auto;\n            }\n            .info-section {\n                width: 50%;\n                h2 {\n                    text-align: left;\n                    margin: 0;\n                    font-size: 1rem;\n                    box-shadow: 0 4px 2px -2px rgb(124, 124, 124);\n                }\n                p {\n                    margin-top: 1vh;\n                }\n\n                img {\n                    max-height: 300px;\n                    max-width: 300px;\n                }\n            }\n        }\n\n        .investigation-tab {\n            .investigation-area {\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n                gap: 1vh;\n                p {\n                    text-align: center;\n                }\n                input {\n                    border-radius: 5px;\n                    height: 5vh;\n                    font-size: 1rem;\n                    width: 50%;\n                }\n                .alert-section {\n                    height: 7vh;\n                    margin: 0.5vh auto;\n                }\n                button {\n                    width: 50%;\n                }\n\n                .investigation-amount {\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    width: 95%;\n                }\n            }\n        }\n    }\n}\n.cctv-admin-form-modal {\n    position: relative;\n    .toggle-btns {\n        position: absolute;\n        right: 20px;\n        .toggle-btn {\n            width: 100px;\n        }\n    }\n    h1 {\n        margin: 0;\n        font-size: 1.5rem;\n        margin-bottom: 5vh;\n    }\n    .cctv-admin-form {\n        display: flex;\n        flex-direction: column;\n        gap: 0.5vh;\n\n        .form-type {\n            min-height: 26vh;\n        }\n\n        .form-row {\n            display: flex;\n            justify-content: space-between;\n            gap: 1vw;\n            .form-col {\n                display: flex;\n                flex-direction: column;\n                gap: 1vh;\n                align-items: flex-start;\n\n                width: 100%;\n                label {\n                    color: #000;\n                    font-weight: 500;\n                }\n                input,\n                select {\n                    border-radius: 5px;\n                    width: 100%;\n                    height: 4vh;\n                }\n                textarea {\n                    border-radius: 5px;\n                    width: 100%;\n                    max-width: 100%;\n                    min-width: 100%;\n                    height: 8vh;\n                    max-height: 8vh;\n                    min-height: 8vh;\n                }\n            }\n        }\n    }\n    .alert-section {\n        height: 10vh;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    .btn-section {\n        display: flex;\n        justify-content: space-between;\n        gap: 1vw;\n        margin-top: 2vh;\n        button {\n            width: 100%;\n        }\n    }\n}\n\n.cctv-admin-help-modal {\n    h1 {\n        margin: 0;\n        font-size: 1.5rem;\n        margin-bottom: 2vh;\n    }\n    .help-main-content {\n        max-height: 40vh;\n        min-height: 40vh;\n        overflow-y: auto;\n        h2 {\n            text-align: left;\n            margin: 0;\n            font-size: 1rem;\n            box-shadow: 0 4px 2px -2px rgb(124, 124, 124);\n        }\n\n        p {\n            color: #000;\n\n            .unactioned-color {\n                background-color: #f8ac48;\n                width: 200px;\n                height: 30px;\n                margin-top: 5px;\n            }\n        }\n    }\n    button {\n        margin-top: 2vh;\n        width: 100%;\n    }\n}\n\n.upload-photo-modal {\n    @include flex();\n    h1 {\n        margin: 0;\n        font-size: 1.5rem;\n    }\n\n    .upload-section {\n        label {\n            font-weight: 500;\n            color: #000;\n        }\n        select {\n            width: 100%;\n            height: 4vh;\n            border-radius: 5px;\n        }\n\n        .img-container {\n            @include flex();\n            height: 30vh;\n            border: 1px solid #000;\n            margin: 1vh auto;\n            position: relative;\n            img {\n                max-height: 28vh;\n                max-width: 100%;\n            }\n            .delete-icon {\n                position: absolute;\n                top: 0;\n                right: 0;\n                cursor: pointer;\n            }\n        }\n\n        input {\n            width: 100%;\n            height: 4vh;\n            color: #000;\n            border-radius: 5px;\n            border: 1px solid #000;\n            padding: 5px;\n        }\n    }\n\n    .alert-section {\n        height: 7vh;\n    }\n\n    .btn-section {\n        @include flex();\n        width: 100%;\n        button {\n            width: 45%;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
